"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Event Types that exist in ART-react-metrics.
 */
var EventType;
(function (EventType) {
    EventType["ENGAGEMENT"] = "ENGAGEMENT";
    EventType["OPERATIONAL"] = "OPERATIONAL";
})(EventType = exports.EventType || (exports.EventType = {}));
/**
 * Unknown event type to be used for internal purposes.
 */
exports.UNKNOWN_TYPE = 'UNKNOWN';
/**
 * This enumeration defines Priority associated with Event when
 * they are being recorded.
 * Priority is used as an indication of time sensitivity of a
 * Event. If the event collector has the functionality of priority then it would
 * be used.
 *
 * Currently exists DCM.
 */
var Priority;
(function (Priority) {
    /**
     * Metrics of normal priority will be batched before they are transmitted.
     */
    Priority[Priority["NORMAL"] = 0] = "NORMAL";
    /**
     * Metrics of high priority will be transmitted immediately
     */
    Priority[Priority["HIGH"] = 1] = "HIGH";
    /**
     * Business critical metrics (e.g. engagement metrics) to be placed in
     * reserved storage space before they are transmitted.
     */
    Priority[Priority["CRITICAL"] = 2] = "CRITICAL";
})(Priority = exports.Priority || (exports.Priority = {}));
//# sourceMappingURL=constants.js.map